import React, { useEffect, useMemo } from "react";

import useServerTime from "@repo/shopify/hooks/useServerTime";
import type { MetafieldReference, Metaobject } from "@repo/shopify/types/generated/storefront.types";

import GoreTexCard from "@molecules/GoreTexCard";
import HomeCard from "@molecules/HomeCard";

import useMetaObjects from "@queries/useMetaObjects";

import { useLayoutStore } from "@store/layout";

const getValue = (node: MetafieldReference | undefined, key: string) => {
  if (!node) return null;
  return (node as Metaobject)?.fields.find((item) => item.key === key);
};

export default function Home() {
  const { showFooter } = useLayoutStore();

  const { serverTime } = useServerTime();

  const { fetchMetaObjectIndex, metaObjectIndexData, metaObjectIndexLoading } = useMetaObjects();

  useEffect(() => {
    showFooter(true);
    window.scrollTo(0, 0);

    void fetchMetaObjectIndex({ type: "index", first: 6, reverse: true });
  }, []);

  const index = useMemo(
    () => metaObjectIndexData?.metaobjects?.edges?.[0]?.node?.fields?.[0]?.references?.edges || [],
    [metaObjectIndexData],
  );

  return (
    <>
      {!metaObjectIndexData && metaObjectIndexLoading ? null : (
        <section className="pc:col-span-12 pc:grid-cols-2 col-span-8 grid grid-cols-1 gap-x-5 gap-y-20">
          {index?.map(({ node }) => {
            const publishDate = new Date(getValue(node, "open_date")?.value || "");
            if (serverTime <= publishDate) return null;

            return getValue(node, "title")?.value === "thisisneverthat® × GORE-TEX® DOWNTOWN LAYER" ? (
              <GoreTexCard key={node?.id} node={node as Metaobject} />
            ) : (
              <HomeCard key={node?.id} node={node as Metaobject} />
            );
          })}
        </section>
      )}
    </>
  );
}
